module.exports = __webpack_public_path__ + "img/lobitozz_new_image_login.496afad6.jpg";